import { useStore } from "@/store";
import {
  Box,
  Modal,
} from "@mantine/core";
import { useRef } from 'react';
import { useScrollPosition } from '@/hooks';

export const DocumentationModal = () => {
  const [IsDocModalOpen, setIsDocModalOpen] = useStore(({ config: c }) => [
    c.getIsDocModalOpen(), c.setIsDocModalOpen
  ]);

  const contentRef = useRef<HTMLDivElement>(null);
  useScrollPosition(contentRef);

  const handleCloseModal = () => {
    setIsDocModalOpen(false);
  };

  return (
    <Modal
      opened={IsDocModalOpen}
      onClose={handleCloseModal}
      title="Documentation"
      overlayProps={{
        opacity: 0.55,
        blur: 3,
      }}
      size = "50rem"
      centered
    >
      <Box style={{ height: '70vh' }} ref={contentRef}>
        Documentation goes here
      </Box>
    </Modal>
  );
};
